import { Injectable, Injector, Optional } from '@angular/core'
import {
  CmsComponent,
  CmsComponentAdapter,
  CmsSiteContextSelectorComponent,
  ContextServiceMap,
  PageType
} from '@spartacus/core'
import { CmsComponentData, SiteContextComponentService } from '@spartacus/storefront'
import { BehaviorSubject, Observable } from 'rxjs'
import { EbBaseSiteService } from './eb-base-site.service'

@Injectable({ providedIn: 'root' })
export class EbSiteContextComponentService extends SiteContextComponentService {
  isContextSelectionDialogOpen$ = new BehaviorSubject(false)

  constructor(
    @Optional()
    protected componentData: CmsComponentData<CmsSiteContextSelectorComponent>,
    contextServiceMap: ContextServiceMap,
    injector: Injector,
    protected ebBaseSiteService: EbBaseSiteService,
    protected cmsComponentAdapter: CmsComponentAdapter
  ) {
    super(componentData, contextServiceMap, injector)
  }

  getItems(): Observable<any> {
    return this.ebBaseSiteService.getAll()
  }

  getContextSelectionDialogVisibility() {
    return this.isContextSelectionDialogOpen$
  }

  setContextSelectionDialogVisibility(isVisible: boolean) {
    this.isContextSelectionDialogOpen$.next(isVisible)
  }

  getCountryComponentData(entries): Observable<CmsComponent[]> {
    return this.cmsComponentAdapter.findComponentsByIds(entries, {
      id: 'country',
      type: PageType.CONTENT_PAGE
    })
  }
}
